import React from "react";
import { 
    // useDispatch, 
    useSelector } from 'react-redux';
import { Redirect } from "react-router-dom";


export default function Lifenotodetails() {
    const islifeno = useSelector(state => state.lifedetail.islifeno)
    console.log(islifeno, "lifenumber")
    if (islifeno) {
        return (
            <Redirect to="/lifeLayout" />
        )
    } else {
        return (
            <Redirect to="/lifeno" />
        )
    }
}
